export const CAMPAGNE_MEDIA = 'api/pub/campagne_media.p';
export const MEDIA = 'api/pub/media.p';
export const CAMPAGNE_TYPES = 'api/pub/campagne_type.p';
export const MAGASINS = 'api/pub/magasin.p';
export const CAMPAGNE_REQ = 'api/pub/campagne_req.p';
export const INSTRUCTIONS = 'api/pub/envoiInstruction.p';
export const DIVISIONS = 'api/pub/division.p';
export const DEPARTEMENT = 'api/pub/departement.p';
export const CATEGORIE = 'api/pub/categorie.p';
export const FORMAT_PAGE = 'api/pub/media_format.p';
export const CAMPAGNE_TYPE_PROD = 'api/pub/campagne_req_prod.p';
export const CAMPAGNE_TYPE_PROD_AFFICHE = 'api/pub/campagne_req_prod_affiche.p';
export const HOT_FOLDER = 'api/hotfolder.p';
export const DOCUMENTS = 'api/pub/pubDocuments.p';
export const TREQ = 'api/pub/call_treq.p';
export const AMBIANCE = 'api/pub/ambiance.p';
export const DIFFUSEURS = 'api/pub/diffuseur.p';
export const RESEAUX = 'api/pub/reseau.p';
export const PROJECT = 'api/pub/projet.p';
export const OBJECTIF = 'api/pub/pub_objectif.p';
export const BANNIERES = 'api/pub/banniere.p';
export const CAMPAGNE_NOTE = 'api/pub/campagne_media_note.p';
export const ANNONCES = 'api/pub/annonce.p';
export const LISTE_USAGER = 'api/pub/liste_usager.p';
export const ANNONCES_VIGUEURS = 'api/pub/annonce_vigueur.p';
export const ANNONCE_PROD = 'api/pub/annonce_prod.p';
export const ANNONCE_PLAN = 'api/pub/annonce_plan.p';
export const CAMPAGNE_DIFFUSEUR = 'api/pub/campagne_diffuseur.p';
export const FOURNISSEURS = 'api/pub/fournisseur.p';
export const PRODUIT_ANNONCE = 'api/pub/rapport/produitAnnonce.p';
export const LISTING_PRODUITS = 'api/pub/listing_produits.p';
export const DOCUMENTS_META = 'api/pub/pubDocumentsMeta.p';
export const DOC_TYPE_META = 'api/pub/docTypeMeta.p';
export const TYPE_ENVOIE_INSTRUCTIONS = 'api/pub/typeEnvoiInstruction.p';
export const INVENTAIRES = 'api/inv/lire_inventaire.p';
export const LOG_IN = 'rest/user/authenticate';
export const CARACT_WEB = 'api/pub/caract_web.p';
export const TACHE = 'api/pub/tache_pub.p';
export const TACHE_PLANIF = 'api/pub/tache_dtl.p';
export const TACHE_ACTIVITE = 'api/pub/tache_activite_pub.p';
export const TACHE_USAGER = 'api/pub/tache_usager_pub.p';
export const THEMATIQUE = 'api/pub/thematique.p';
export const REGISTRE_APPROBATION = 'api/pub/registre_approb_doc.p';
export const RAPPORT_COOP = 'api/pub/rapport/rapportCoop.p';
export const ACHATS_MEDIAS = 'api/pub/rapport/campagneCout.p';

export const INV_PREFIX_QUERY = 'methode=lire&mode=entete&';
export const INV_PREFIX_QUERY_NEXT = 'mode=entete&methode=suiv&';
export const INV_PREFIX_QUERY_BEFORE = 'mode=entete&methode=prev&';
export const INV_KEY = 'Inventaire';

export const SELECT_ALL = 'Tous';
export const SEARCH_QUERY_PROJECT = 'search_query_project';
export const SOLR =
  'https://3d-viewer-api.azurewebsites.net:443/api/solr/triggers/When_a_HTTP_request_is_received/invoke?api-version=2022-05-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=KhSj8qctaANZaPvyXSOOqdZU4TJB5vMyfoCm2pWEZpo';
export const MIN_WIDTH = 768;
export const DOCUMENT = 'https://partage.tanguay.ca/docpublicite/';
